import { render, staticRenderFns } from "./UploadPhoneFile.vue?vue&type=template&id=2fbcf34c&scoped=true&"
import script from "./UploadPhoneFile.vue?vue&type=script&lang=js&"
export * from "./UploadPhoneFile.vue?vue&type=script&lang=js&"
import style0 from "./UploadPhoneFile.vue?vue&type=style&index=0&id=2fbcf34c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbcf34c",
  null
  
)

export default component.exports